import { parse } from 'date-fns';
import { getDefaultFormats, convertSystemDateToZonedDate } from './DateUtils2.js';
import { getNow } from './DateUtils3.js';
import { hijriToGregorian } from './DateUtils38.js';

/**
 * @param tzFormattedDate string of formatted date
 * @param hasSeconds
 * @param calendar hijri or gregorian, default is gregorian
 * @param unMaskedDate the date to parse in format "DDMMYYYY", this is used for hijri only
 * @returns parsing result, isValid with valid Date in case of validity
 */
const parseTzFormattedDateTime = (tzFormattedDate, hasSeconds = false, calendar, unMaskedDate) => {
    const { defaultFormats } = getDefaultFormats();
    if (!tzFormattedDate)
        return {
            date: undefined,
            isValid: false,
        };
    const format = hasSeconds ? defaultFormats.dateTimeFormatWithSeconds : defaultFormats.dateTimeFormat;
    const newDate = parse(tzFormattedDate, format, getNow());
    if (!isNaN(newDate.getTime()) && format.length === tzFormattedDate.length) {
        const validDate = convertSystemDateToZonedDate(newDate);
        return {
            date: calendar === 'hijri'
                ? hijriToGregorian(validDate.getDate(), (validDate === null || validDate === void 0 ? void 0 : validDate.getMonth()) + 1, validDate === null || validDate === void 0 ? void 0 : validDate.getFullYear())
                : validDate,
            isValid: true,
        };
    }
    else {
        if (calendar === 'hijri') {
            // handle the case of parse failure for 29/2/YYYY hijri date
            const hijriSplit = [unMaskedDate === null || unMaskedDate === void 0 ? void 0 : unMaskedDate.substring(0, 2), unMaskedDate === null || unMaskedDate === void 0 ? void 0 : unMaskedDate.substring(2, 4), unMaskedDate === null || unMaskedDate === void 0 ? void 0 : unMaskedDate.substring(4, 8)];
            if ((hijriSplit === null || hijriSplit === void 0 ? void 0 : hijriSplit[0]) == '29' && (hijriSplit === null || hijriSplit === void 0 ? void 0 : hijriSplit[1]) == '02') {
                const year = (hijriSplit === null || hijriSplit === void 0 ? void 0 : hijriSplit[2]) ? parseInt(hijriSplit === null || hijriSplit === void 0 ? void 0 : hijriSplit[2]) : undefined;
                if (year)
                    return {
                        date: hijriToGregorian(29, 2, year),
                        isValid: true,
                    };
            }
        }
        return {
            date: undefined,
            isValid: false,
        };
    }
};

export { parseTzFormattedDateTime };
